import {PropsWithChildren, ReactElement} from "react";
import classNames from "classnames";

interface Props {
    className?: string;
    bodyRef?: (node: HTMLDivElement) => void;
}

function FrameBottomPanelBody(props: PropsWithChildren<Props>): ReactElement {

    return (
        <div ref={props.bodyRef}
            className={classNames("frame-one-bottom-panel_body", props.className)}>
            {props.children}
        </div>
    );
}

export default FrameBottomPanelBody;
